import { createSlice } from "@reduxjs/toolkit";
import { getDaysOfWeek } from "../services/setting_service";

// ----------------------------------------------------------------------

const slice = createSlice({
  name: "section",

  initialState: {
    isLoadingGetDaysOfWeek: false,
    daysOfWeek: [],
  },

  reducers: {},

  extraReducers: {
    // ==> addSectionToClass
    [getDaysOfWeek.fulfilled]: (state, action) => {
      state.isLoadingGetDaysOfWeek = false;
      state.daysOfWeek = action.payload.data;
    },
    [getDaysOfWeek.rejected]: (state, action) => {
      state.isLoadingGetDaysOfWeek = false;
    },
    [getDaysOfWeek.pending]: (state) => {
      state.isLoadingGetDaysOfWeek = true;
    },
  },
});

// Reducer
export default slice.reducer;

// Actions
// export const {  } = slice.actions;
